<template>
  <div class="hotelux-header">
    <div class="hotelux-header-inner">
      <div class="header-left">
        <responsive-logo
          v-if="showLogo"
          :src="currentLogo"
          :horizontal="{
            container: { width: '104px', height: '36px' },
            image: { maxWidth: '104px', maxHeight: '36px' }
          }"
          position="top-left"
          @click="handleLogoClick"
        />
      </div>

      <div class="header-center">
        <slot name="center" />
      </div>

      <div class="header-right">
        <currency-selector
          v-if="showCurrency"
          v-model="currency"
          @change="handleCurrencyChange"
        />

        <current-user
          :is-sticky="isSticky"
          @member="handleMemberClick"
          :settings="headerSettings"
        />

        <member-drawer :settings="headerSettings" v-model:show="memberDrawer" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { headerSettings } from "@consumerY/config/index";
import ResponsiveLogo from "@ui/ResponsiveLogo/index.vue";
import { storeToRefs } from "pinia";
import { computed, ref } from "vue";
import { useRouter } from "vue-router";

import { useChannelStoreHook } from "@/store/modules/channel";
import { useUserStoreHook } from "@/store/modules/user";

import CurrencySelector from "../CurrencySelector/index.vue";
import CurrentUser from "../CurrentUser/index.vue";
import MemberDrawer from "../MemberDrawer/index.vue";

const props = defineProps({
  logoUrl: {
    type: String,
    default: ""
  },
  showLogo: {
    type: Boolean,
    default: true
  },
  showCurrency: {
    type: Boolean,
    default: true
  },
  isSticky: {
    type: Boolean,
    default: false
  }
});

const router = useRouter();
const memberDrawer = ref(false);
const { channel } = useChannelStoreHook();
const userStore = useUserStoreHook();
const { currency } = storeToRefs(userStore);

const currentLogo = computed(() => {
  if (props.isSticky) {
    return "https://qiniu-uploads-cdn.charmdeer.com/HL_logo_B.png";
  }
  console.log(props.logoUrl, "l", channel?.logoDetail?.rectangle);
  return props.logoUrl || channel?.logoDetail?.rectangle;
});

const handleCurrencyChange = async newCurrency => {
  await userStore.changeCurrency(newCurrency);
};

const handleMemberClick = () => {
  memberDrawer.value = true;
};

const handleLogoClick = () => {
  router.push({
    path: "/",
    query: { channel: channel.key }
  });
};

defineOptions({
  name: "HoteluxHeader"
});
</script>

<style lang="scss" scoped>
.hotelux-header {
  position: relative;
  width: 100%;
  z-index: 10;
}

.hotelux-header-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}

// 左右两列等宽，中间列按内容宽度居中，搜索条才会落在页头正中间
.header-left {
  display: flex;
  flex: 1;
  align-items: center;

  :deep(.responsive-logo) {
    cursor: pointer;
  }
}

.header-center {
  display: flex;
  flex: none;
  align-items: center;
}

.header-right {
  display: flex;
  flex: 1;
  justify-content: flex-end;
  align-items: center;
  gap: 16px;
}
</style>
